export const getAnnouncement = ({cancelToken}) => {
  return {method: 'GET', endpoint: `/api/auth/announcement`, cancelToken};
};

export const getAnnouncementPublic = ({cancelToken}) => {
  return {method: 'GET', endpoint: `/api/announcement`, cancelToken};
};
